// apps/client/src/firebase/config.ts (CONVERTED TO TYPESCRIPT)

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  functionsRegion: string;
}

/**
 * Best Practice: Build-Time Configuration.
 *
 * This file exports the Firebase configuration variables that were embedded 
 * into the application at build time. The selection of which .env file to use 
 * is handled by the build script in your `package.json`.
 */

export const firebaseConfig: FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_APP_ID || '',
  functionsRegion: process.env.REACT_APP_FUNCTIONS_REGION || 'australia-southeast1',
};

// Lightweight debug log to confirm which configuration was successfully built.
  // console.log(



// Also export as default for maximum compatibility with different import styles.
export default firebaseConfig;